<div class="detail-page-card">
    @if (!config.hideHeader) {
        <div class="detail-page-card-title">{{ config.name }}</div>
    }
    @if (ready) {
        @if (!tableData || tableData.length == 0) {
            <div class="detail-page-card-body padded">
                <small>
                    @if (config.emptyMessage) {
                        {{ config.emptyMessage }}
                    } @else {
                        No {{ config.name | lowercase }} available.
                    }
                </small>
            </div>
        }
    } @else {
        <div class="detail-page-card-body padded cerrix-control-sm">
            <div class="fancy-loader submodule"></div>
        </div>
    }

    @if (scopedTableData && scopedTableData.length > 0) {
        <div class="detail-page-card-body overflow-auto">
            <table class="table-cerrix rounded striped bordered-columns reset table-hoverable">
                <thead>
                    <tr #theadRow>
                        <th class="small-header"></th>
                        @for (field of config.fields; track field) {
                            @if (!field.hideInOverview) {
                                <th class="text-center">
                                    {{ field.prettyName ? field.prettyName : field.fieldName }}
                                </th>
                            }
                        }
                        @if (config.overviewRowActions) {
                            <th></th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (
                        outerData of scopedTableData;
                        track outerData;
                        let even = $even;
                        let odd = $odd
                    ) {
                        <tr
                            class="row-hover"
                            [ngClass]="{
                                highlighted: activeRow && activeRow[idProp] == outerData[idProp],
                                'even-row': even,
                                'odd-row': odd,
                            }"
                            (click)="triggerClick(outerData)"
                        >
                            <td
                                class="text-center small-header"
                                (click)="
                                    getLinkedIds(outerData);
                                    outerData.showEditor = !outerData.showEditor
                                "
                            >
                                @if (config.innerConfig) {
                                    <div>
                                        <span>
                                            <i
                                                class="far"
                                                [class.fa-minus-square]="outerData.showEditor"
                                                [class.fa-plus-square]="!outerData.showEditor"
                                            ></i>
                                        </span>
                                    </div>
                                }
                            </td>
                            @for (field of config.fields; track field) {
                                @if (!field.hideInOverview) {
                                    <td class="text-truncate text-center">
                                        <workspace-cell
                                            [configs]="config.rendererConfig"
                                            [row]="outerData"
                                            [header]="field.fieldName"
                                        >
                                        </workspace-cell>
                                    </td>
                                }
                            }
                            @if (config.overviewRowActions) {
                                <td class="text-center">
                                    @for (action of config.overviewRowActions; track action) {
                                        <span>
                                            <i
                                                class="{{ action.icon }}"
                                                matTooltip="{{ action.tooltip }}"
                                                (click)="action.clickEvent(outerData)"
                                            >
                                            </i>
                                        </span>
                                    }
                                </td>
                            }
                        </tr>
                        @if (outerData.showEditor && config.innerConfig) {
                            <tr class="inner-table">
                                <td [colSpan]="theadRow.childElementCount">
                                    @let innerConfig = setupInnerconfig(outerData);
                                    @if (innerConfig) {
                                        <cerrix-table-multi-level [config]="innerConfig">
                                        </cerrix-table-multi-level>
                                    }
                                </td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
            @if (scopedToggleAllowed) {
                <div class="custom-pagination" (click)="toggleScopedTableData()">
                    View
                    {{
                        scopedTableExpanded
                            ? "last " + config.limitViewTo
                            : "all " + config._visibleRowCount
                    }}
                </div>
            }
        </div>
    }
</div>
